import { ApiRest } from './Api';
import axios from 'axios';
import { formatFileName } from '../helpers/HelperFunctions'

/**
 * 
 * @param {string} pswd 
 * @returns token
 * 
 * funcion que llama al EP para traer el token de autenticacion
 * se envia por el header la contransena con el x-api-key
 */
export const requestSignIn = async (pswd) => {
    try {
        const apiRest = new ApiRest(
            {
                'Authorization': 'Basic '+ btoa(`${process.env.REACT_APP_ACCOUNT}:` + pswd)
            },
            process.env.REACT_APP_API_REPORT
        );
        return (
          await apiRest.post({
            url: '/auth/signin',
          })
        );
      } catch (e) {
        throw e;
      }
}

/**
 * 
 * @param {string} type
 * funcion para realizar una descarga de archivo desde el servidor de reportes 
 */
export const getReport = async (type, dates) => {
    try {
        await axios({
            url: dates !== null 
                ? `${process.env.REACT_APP_API_REPORT}/reports/${type}?startDate=${dates.startDate}&endDate=${dates.endDate}` 
                : `${process.env.REACT_APP_API_REPORT}/reports/${type}`,
            method: 'GET',
            headers: {
                "authorization": `Bearer ${JSON.parse(window.localStorage.getItem('dataLogin'))?.token}`
            },
            responseType: 'blob', // importante
          }).then((response) => {
             const url = window.URL.createObjectURL(new Blob([response.data]));
             const link = document.createElement('a');
             link.href = url;
             link.setAttribute('download', `${formatFileName(type)}.xlsx`); //or any other extension
             document.body.appendChild(link);
             link.click();
          });
      } catch (e) {
        throw e;
      }
}

/**
 * 
 * @param {formdata} file 
 * @param {string} type 
 * @returns json
 * funcion para subir archivos al servidor de reportes
 */
export const fileUpload = async (file, type) => {
    try {
        const url = `${process.env.REACT_APP_API_REPORT}/reports/${type}`;
        const formData = new FormData();
        formData.append('file',file)
        const config = {
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                "authorization": `Bearer ${JSON.parse(window.localStorage.getItem('dataLogin'))?.token}`
            }
        }
        const res = await axios.post(url, formData, config)
        return res
    } catch (e) {
        return e.response.data;
    }
}

/**
 * 
 * @param {formdata} file 
 * @param {string} type 
 * @returns json
 * funcion para subir archivos al servidor de reportes (dispersion)
 */
export const fileUploadDispertion = async (file) => {
    try {
        const url = `${process.env.REACT_APP_API}/api/v1/dispersion/rejected`;
        const formData = new FormData();
        formData.append('file',file)
        const config = {
            headers: {
                'content-type': 'multipart/form-data',
                "x-api-key": process.env.REACT_APP_API_KEY
            }
        }
        const res = await axios.post(url, formData, config)
        return res
    } catch (e) {
        return e.response.data;
    }
}

/**
 * 
 * @param {formdata} file 
 * @param {string} type 
 * @returns json
 * funcion para subir archivos al servidor de reportes (dispersion)
 */
export const fileUploadConfig = async (file) => {
    try {
        const url = `${process.env.REACT_APP_API_REPORT}/payment/extra/adjustment`;
        const formData = new FormData();
        formData.append('file',file)
        const config = {
            headers: {
                'content-type': 'application/x-www-form-urlencoded',
                "authorization": `Bearer ${JSON.parse(window.localStorage.getItem('dataLogin'))?.token}`
            }
        }
        const res = await axios.post(url, formData, config)
        return res
    } catch (e) {
        return e.response.data;
    }
}